/**
 * Columns a station can put in a listener export. Keys match the
 * segmentation service's export catalog; anything else it ignores.
 */
export const EXPORT_FIELD_GROUPS = [
  {
    label: 'Identity',
    icon: 'fa-id-card-o',
    fields: [
      { key: 'originator', label: 'Originator', locked: true },
      { key: 'name', label: 'Name' },
      { key: 'mobile', label: 'Mobile number' },
      { key: 'email', label: 'Email' },
      { key: 'originator_type', label: 'Originator type' },
    ],
  },
  {
    label: 'Engagement',
    icon: 'fa-bolt',
    fields: [
      { key: 'segment', label: 'Segment' },
      { key: 'channel', label: 'Main channel' },
      { key: 'channels', label: 'All channels' },
      { key: 'recency_days', label: 'Days since last activity' },
      { key: 'last_interaction', label: 'Last interaction date' },
      { key: 'first_interaction', label: 'First interaction date' },
      { key: 'interactions_total', label: 'Total interactions' },
      { key: 'interactions_30d', label: 'Interactions (30 days)' },
      { key: 'tags', label: 'Tags' },
    ],
  },
  {
    label: 'Demographics',
    icon: 'fa-users',
    fields: [
      { key: 'gender', label: 'Gender' },
      { key: 'age_group', label: 'Age group' },
      { key: 'location', label: 'Location' },
      { key: 'language', label: 'Language' },
      { key: 'ethnicity', label: 'Ethnicity' },
      { key: 'lsm', label: 'LSM tier' },
    ],
  },
  {
    label: 'AI & consent',
    icon: 'fa-magic',
    fields: [
      { key: 'interests', label: 'Interests (AI)' },
      { key: 'return_likelihood', label: 'Return outlook' },
      { key: 'opt_in', label: 'Opted in' },
      { key: 'permission', label: 'Permission' },
    ],
  },
  {
    label: 'Export',
    icon: 'fa-download',
    fields: [{ key: 'export_date', label: 'Export date' }],
  },
];

/** Offered only when exporting from the retarget bucket. */
export const BUCKET_FIELDS = [{ key: 'group', label: 'Retarget group' }];

export const EXPORT_PRESETS = [
  { label: 'Just originator', fields: ['originator'] },
  { label: 'Contact list', fields: ['originator', 'name', 'mobile', 'email', 'channel', 'opt_in'] },
  {
    label: 'Audience profile',
    fields: ['originator', 'segment', 'gender', 'age_group', 'location', 'language'],
  },
  {
    label: 'Engagement',
    fields: [
      'originator',
      'segment',
      'channel',
      'last_interaction',
      'interactions_total',
      'recency_days',
    ],
  },
];

export const DEFAULT_EXPORT_FIELDS = ['originator'];

/** Quotes a CSV cell (commas, quotes and newlines). */
export const csvCell = value => {
  const text = value === null || value === undefined ? '' : String(value);
  return /[",\n\r]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

/** { fields: [{label}], rows: [[...]] } -> CSV text. */
export const toCsv = ({ fields, rows }) =>
  [fields.map(f => csvCell(f.label)).join(','), ...rows.map(r => r.map(csvCell).join(','))].join(
    '\n',
  );



// WEBPACK FOOTER //
// ./src/components/segmentation/utils/exportFields.js